import { TAB_LABEL, type Tab } from "@po/shared";
import { useDashboard } from "../pages/Dashboard";
import { byLabel, PROCUREMENT_TABS } from "./Sidebar";

/** Underline tabs of a section, alphabetical as in the side rail; Procurement's (in purchase order) unless given. */
export function TabBar({ tabs }: { tabs?: readonly Tab[] }) {
  const { tab, setSearch } = useDashboard();
  return (
    <nav className="overflow-x-auto" aria-label="Tabs">
      <div role="tablist" className="flex gap-5 min-w-max">
        {(tabs ? byLabel(tabs) : PROCUREMENT_TABS).map((t) => (
          <button
            key={t}
            role="tab"
            aria-selected={tab === t}
            onClick={() => setSearch({ tab: t })}
            className={`py-1.5 text-[13.5px] font-semibold border-b-2 whitespace-nowrap ${
              tab === t ? "border-brand-2 text-brand-2" : "border-transparent text-ink2 hover:text-ink"
            }`}
          >
            {TAB_LABEL[t]}
          </button>
        ))}
      </div>
    </nav>
  );
}
